module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 form-control-label"
  }, [_vm._v("Часовой пояс")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.timeZones,
      "close-on-select": true,
      "show-labels": false,
      "value": _vm.value,
      "placeholder": "Часовой пояс не выбран",
      "track-by": "id",
      "label": "name",
      "autocomplete": "off"
    },
    on: {
      "input": _vm.changeTimeZone
    },
    model: {
      value: (_vm.timeZone),
      callback: function($$v) {
        _vm.timeZone = $$v
      },
      expression: "timeZone"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/production/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-2ed59ac4"}!/home/alarmplan/production/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Techcenter/components/TcSelectTimeZone.vue
// module id = 1018
// module chunks = 1